// Reopen Shopify's native preferences without altering saved consent.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-neoman-cookie-preferences]');
  if (!button) return;
  if (typeof window.privacyBanner?.showPreferences === 'function') {
    window.privacyBanner.showPreferences();
  } else {
    const status = document.getElementById('neoman-cookie-status');
    if (status) status.textContent = 'Les préférences ne sont pas encore disponibles. Réessayez dans quelques instants.';
  }
});
